import type { CostScope } from './api';

/**
 * Onde a tela de custos está: na lista, ou no detalhe de um cliente/workflow.
 *
 * A identidade vira CAMINHO (`/costs/cliente/<id>`) e não query, porque é outra
 * tela — o link é legível, o voltar do navegador desfaz um passo, e o período e
 * os filtros continuam na query, que é o que muda dentro da mesma tela.
 */
export class CostRoute {
  private static readonly BASE = '/costs';
  private static readonly SCOPES: readonly CostScope[] = ['cliente', 'workflow'];

  private constructor(
    readonly scope: CostScope | null,
    readonly id: string | null,
  ) {}

  static list(): CostRoute {
    return new CostRoute(null, null);
  }

  static of(scope: CostScope, id: string): CostRoute {
    return new CostRoute(scope, id);
  }

  /** Caminho abaixo de `/costs` que não nomeia escopo conhecido volta para a lista. */
  static fromPath(path: string): CostRoute {
    const rest = path.replace(/\/+$/, '').slice(CostRoute.BASE.length).replace(/^\//, '');
    if (!rest) return CostRoute.list();

    const separator = rest.indexOf('/');
    if (separator < 0) return CostRoute.list();

    const scope = rest.slice(0, separator) as CostScope;
    const id = decodeURIComponent(rest.slice(separator + 1));
    if (!CostRoute.SCOPES.includes(scope) || !id) return CostRoute.list();
    return new CostRoute(scope, id);
  }

  get showsDetail(): boolean {
    return this.scope !== null && this.id !== null;
  }

  get path(): string {
    if (!this.showsDetail) return CostRoute.BASE;
    return `${CostRoute.BASE}/${this.scope}/${encodeURIComponent(this.id as string)}`;
  }
}
